import { render } from "./RegisterVerification.vue?vue&type=template&id=29a612e4"
import script from "./RegisterVerification.vue?vue&type=script&lang=js"
export * from "./RegisterVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__